import { FC, Link, Outlet} from 'external/react'

import IconProfile from 'components/IconProfile'

import AccountingMenu from 'layout/Menus/AccountingMenu'
import { withContext } from 'context/index'

const AccountingLayout: FC = () => {
	
	return (
		<>
			<div className='navbar navbar-light navbar-expand justify-content-between bg-white shadow header--navbar sticky-top'>
			<span className='navbar-brand'>
				<Link to={'/acoounting'} className='navbar-brand fw-bold' style={{ color: '#42C3DB' }} >
					EduSystem
				</Link>
			</span>
			<div className='navbar-collapse principal-menu' style={{justifyContent: 'flex-end'}} id='navbar-collapse'>
					<ul className='nav navbar-nav ml-auto'>
						<AccountingMenu />
						<IconProfile path='accounting' />
					</ul>
				</div>
			</div>
			<Outlet />
		</>
	)
}

export default withContext(AccountingLayout, 'accounting')
